"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _iconDemandResponse = _interopRequireDefault(require("../../icons/icon-demand-response.svg"));

var _iconConfigureProducts = _interopRequireDefault(require("../../icons/icon-configure-products.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconComponentsMap = {
  dr: _iconDemandResponse["default"],
  install: _iconConfigureProducts["default"]
};

var AddOnIcon = function AddOnIcon(_ref) {
  var className = _ref.className,
      type = _ref.type;
  var IconComponent = IconComponentsMap[type];

  if (!IconComponent) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(IconComponent, {
    className: className
  });
};

AddOnIcon.propTypes = {
  className: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(Object.keys(IconComponentsMap))
};
AddOnIcon.defaultProps = {
  className: null,
  type: null
};
var _default = AddOnIcon;
exports["default"] = _default;